import { useQuery } from "@tanstack/vue-query";
import languagesService from "@/services/languages.js";

export const useGetLanguagesData = (limit, page, q) => {
  return useQuery({
    queryKey: ["fetchLanguagesData", limit, page, q],
    queryFn: () => languagesService.list(limit, page, q.value ?? "").then((val) => val),
    staleTime: 0,
  });
};
